import { mutate, read } from "./console";

// ---------------------------------------------------------------------------
// Sweep §4 / 0215. The public application page's two calls. No session: the
// link token in the path is the whole address, and it is public on purpose —
// an agency prints it on a poster.
// ---------------------------------------------------------------------------

export type ApplicationForm = { organisation: string; roles: { id: string; name: string }[] };

export type ApplicationPayload = {
  given_name: string;
  family_name: string;
  email: string;
  phone: string;
  home_locality: string;
  role_ids: string[];
  right_to_work: boolean;
  consent: boolean;
  turnstile_token?: string;
};

export const apply = {
  form: (base: string, token: string) => read(base, `/v1/apply/${encodeURIComponent(token)}`),
  submit: (base: string, token: string, payload: ApplicationPayload) =>
    mutate("POST", base, `/v1/apply/${encodeURIComponent(token)}`, payload),
};
